<app-page-title [heading]="heading" [subheading]="subheading" [icon]="icon" [searchEnabled]="true" [searchCallback]="filterSegments"></app-page-title>
<div class="card">
    <div class="card-body row">
        <div class="col-lg-6 text-left">
            <!--<app-search-box></app-search-box>-->
        </div>
        <div class="col-lg-6 text-right">
            <a routerLink="/segments/file-upload" routerLinkActive="active-item"
                [routerLinkActiveOptions]="{exact: true}" class="vsm-link">
                <button type="button" class="btn-shadow d-inline-flex align-items-center btn btn-success">
                    New segment
                </button>
            </a>

        </div>
    </div>
</div>
<eris-table [dataSource]="segmentsDataSource" #parent>
    <ng-container *ngFor="let segment of parent.data; index as i">
        <tr>
            <td class="align-middle">{{ segment.fileName}}</td>
            <td class="align-middle">{{ segment.createdOn | date }}</td>
            <td class="align-middle">
                <ng-container *ngIf="segment.uploadedRecords == 0">...</ng-container>
                <ng-container *ngIf="segment.uploadedRecords > 0">{{ segment.uploadedRecords | number:'':'es' }}</ng-container> 
            </td>
            <td class="align-middle">
                <ng-container *ngIf="segment.matchedRecords == 0">...</ng-container>
                <ng-container *ngIf="segment.matchedRecords > 0">{{  segment.matchedRecords | number:'':'es' }}</ng-container> 
            </td>
            <td class="align-middle">
                <div>
                    <div class="font-icon-wrapper">
                        <i [class]="getStatusStyle(segment)"></i>
                    </div>
                    <div class="d-flex justify-content-center">
                        {{ getStatusLabel(segment) }}
                    </div>
                </div>
            </td>
            <td class="align-middle">
                <eris-menu [context]="segment" [menuConfiguration]="menuConfiguration" [onMenuClosed]="onMenuClosed" [onMenuOpened]="stopRefreshPolling">                    
                </eris-menu>                
            </td>
        </tr>
    </ng-container>
</eris-table>